import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=63f5ade5"
import script from "@/scripts/dashboard/dashboard.js?vue&type=script&lang=js&external"
export * from "@/scripts/dashboard/dashboard.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=63f5ade5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports